import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/reset.css";
import "toastr/build/toastr.min.css";
// Cascade order: tokens → preflight → design system → Tailwind utilities → dark bridge.
import "./styles/tokens.css";
import "./styles/tailwind-base.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/data.css";
import "./styles/shell.css";
import "./styles/legacy.css";
import "./index.css";
import "./styles/theme-bridge.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "react-phone-number-input/style.css";
import "./config/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "context/auth-context";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider } from "context/theme-context";

// Apply the saved theme before the first render so dark-mode users don't see a light flash.
try {
  if (window.localStorage.getItem("zs-theme") === "dark") {
    document.documentElement.setAttribute("data-theme", "dark");
    document.documentElement.classList.add("dark");
  }
} catch {
  // Storage unavailable: fall back to the default light theme.
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <GoogleOAuthProvider clientId="8294018965-627vos0013dk70i10d6l8fvr03ci0uhk.apps.googleusercontent.com">
              <App />
            </GoogleOAuthProvider>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
